import queryString from 'query-string';

const options = { arrayFormat: 'separator', arrayFormatSeparator: "," };
export const parse = string => queryString.parse(string, options);
export const stringify = object => queryString.stringify(object, options);
export const url = (base, params) => base + '?' + stringify(params);